import { register } from '../../../JavaScript/Utils'

// import type { Splide } from './Carousel.types'

declare global {
  interface Window {
    Splide?: Splide,
    splide?: any
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any

export const JobTeaser = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')

    const carousel = new Splide(sliderContainer, {
      type: 'slide',
      grid: {
        rows: 3,
        cols: 1,
        gap : {
          row: '1.5rem',
          col: '1.5rem',
        },
      },
      classes: {
        pagination: 'splide__pagination',
        page: 'splide__pagination__page'
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          grid: {
            rows: 2,
            cols: 2,
          },
        },
        1024: {
          grid: {
            cols: 3,
          },
        }
      }
    })

    carousel.on( 'pagination:mounted', function ( data: { list: { classList: { add: (arg0: string) => void } }; items: any[] } ) {
      data.items.forEach( function ( item ) {
        item.button.textContent = String( item.page + 1 );
      } );
    } );

    carousel.mount( window.splide.Extensions )
  }

  init()
}

register('JobTeaser', JobTeaser)
